import { useEffect, useState } from "react";

/**
 * Returns true when viewport width >= breakpoint (default 768px/Tailwind md).
 * SSR-safe: defaults to false during first render on the server.
 */
export const useIsDesktop = (breakpoint = 768) => {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(`(min-width: ${breakpoint}px)`);
    const handler = (e) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [breakpoint]);

  return isDesktop;
};
